import _objectSpread from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.string.link.js";
import env from '@tencent/vft-common/env';
import weixin from '@tencent/vft-common/weixin';
import setMutiShare from '@tencent/vft-common/share/multi-share';
import { buildUrl } from '@tencent/vft-common/url';
import { getUrlParam } from '@tencent/vft-common/util';
var isQQNews = env.isQQNews,
    isQQSports = env.isQQSports;
/* 分享图不要掺杂多余参数 */

export function processShareLink() {
  var setting = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.pageSetting;
  var _setting$分享链接 = setting.分享链接,
      link = _setting$分享链接 === void 0 ? '' : _setting$分享链接;
  var _window$location = window.location,
      origin = _window$location.origin,
      pathname = _window$location.pathname;
  if (!link) link = "".concat(origin).concat(pathname);
  var tdeId = getUrlParam('_tde_id');
  var from = env.isApp ? 1 : env.isQQNews ? 3 : 2;
  var url = buildUrl(link, _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, getUrlParam('is_prepublish') === '1' ? {
    is_prepublish: 1
  } : null), getUrlParam('ptag', link) ? null : {
    ptag: 'share'
  }), getUrlParam('fromtv') === '1' ? {
    fromtv: 1
  } : null), tdeId ? {
    _tde_id: tdeId
  } : null), {}, {
    p_from: from
  }));
  Object.assign(setting, {
    分享链接: url
  });
}
export function setShare(options) {
  console.log('🚀 setShare', options); // 体育分享

  if (isQQSports) {
    var title = options.title,
        desc = options.desc,
        imgUrl = options.imgUrl,
        link = options.link;
    window.TencentSports.appSdk.setShare({
      title: title,
      desc: desc,
      image: imgUrl,
      url: link
    });
  } else if (isQQNews) {
    setMutiShare(options);
  } else {
    // 走默认
    weixin.setAllShare(options);
  }
}